export const maxLengthArrayRule = (maxLength: number) => ({
	name: 'max-length-array',
	validate: (value: unknown[]) => value.length <= maxLength,
});
